import React, { useState, useEffect, useRef } from "react";
import { accountAPI, reminderAPI } from "services";
import Account from "./Account";
import ExpandableButton from "components/ExpandableButton";
import useUniversalStore from "store/universalStore";
import Filters from "./Filters";
import { ConfirmationModal, Loader, AccountShimmer } from "components";

const KhataList = () => {
  const { accounts, write, accountId, user } = useUniversalStore((state) => state);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(true);
  const listRef = useRef(null); // Reference to the list container
  const selectedAccountRef = useRef(null);
  const [KhataType, setKhataType] = useState("own");

  useEffect(() => {
    if (accounts) {
      setLoading(false);
    }
  }, [accounts]);

  useEffect(() => {
    if (accountId) setSelectedId(accountId);
  }, [accountId]);

  // Scroll to selected account
  useEffect(() => {
    const selectedEl = selectedAccountRef.current;
    const listEl = listRef.current;

    if (selectedEl && listEl) {
      listEl.scrollTo({
        top: selectedEl.offsetTop - 300,
        behavior: "smooth",
      });
    }
  }, [selectedId]);

  const goToKhata = (_id, account) => {
    // Save the current scroll position before updating the state
    const scrollPosition = listRef.current.scrollTop;
    // setSelectedId(_id);

    // check if the account is shared and the user is not the owner
    const isSharedAccount = accountAPI.checkIsSharedAccount(account);

    write({
      isSharedAccount,
      accountId: _id,
      selectedMonth: new Date()
    }); // Update the accountId in the global state

    // Restore the scroll position after the state update
    setTimeout(() => {
      listRef.current.scrollTop = scrollPosition;
    }, 0);
  };

  const handleKhataTypeChange = (type) => {
    setKhataType(type);
  };

  return (
    <>
      <div className="d-flex flex-column vh-100 overflow-auto">
        <Filters setFilteredAccounts={setFilteredAccounts} setLoading={setLoading} KhataType={KhataType} />
        <div className="btn-group w-100 p-2" role="group">
          <button
            type="button"
            className={`btn btn-outline-danger btn-block ${KhataType === "own" ? "active" : ""}`}
            onClick={(e) => handleKhataTypeChange("own")}
          >
            Your Khata
          </button>
          <button
            type="button"
            className={`btn btn-outline-danger btn-block ${KhataType === "shared" ? "active" : ""}`}
            onClick={(e) => handleKhataTypeChange("shared")}
          >
            Shared With You
          </button>
        </div>
        <ul className="list-group list-group-flush overflow-auto flex-grow-1 scrollbar-design " ref={listRef} style={{ paddingBottom: '140px' }}>
          {loading ? (
            Array(8).fill(0).map((_, i) => <AccountShimmer key={i} />)
          ) : (
            filteredAccounts?.map((account, rowId) => (
              <Account
                key={rowId}
                account={account}
                accountRef={account.id === selectedId ? selectedAccountRef : null}
                isSelected={account.id === selectedId}
                onSelect={() => {
                  if (!account.get("cancelled")) {
                    goToKhata(account.id, account);
                  }
                }}
              />
            ))
          )}
        </ul>
      </div>
      <div className="addAccount-btn">
        <ExpandableButton
          title="Add Account"
          formId="newAccount"
          icon="bi bi-person-plus-fill"
        />
      </div>
      {/* <ConfirmationModal id="closeAccountModal" onClick={closeAccount} /> */}
    </>
  );
};

export default KhataList;